import Keys from "../constants/helper";
import { USE_CACHE_IF_AVAILABLE } from "../constants";
import type { IContentContext } from "../store/player/playerSlice";

interface HandlePlayParams {
  profileId: number | string | null;
  data: number | null;
  isVideoPlayerOpen?: boolean;
  dispatch: (action: any) => void;
  setIsLoader: (value: boolean) => void;
  getContentDetails: (
    params: { id: number; role?: string | null; profile_id?: string | number },
    preferCacheValue?: boolean,
  ) => Promise<any>;
  openVideoPlayer: (payload: any) => any;
  contentContext?: IContentContext | null;
  onError?: () => void;
  preferCacheValue?: boolean;
}

export const handlePlayCustom = async ({
  profileId,
  data,
  dispatch,
  isVideoPlayerOpen,
  setIsLoader,
  getContentDetails,
  openVideoPlayer,
  contentContext,
  onError,
  preferCacheValue = USE_CACHE_IF_AVAILABLE,
}: HandlePlayParams): Promise<void> => {
  setIsLoader(true);

  if (profileId && data) {
    try {
      const role = localStorage.getItem(Keys.EPIC_USER_ROLE);
      const response = await getContentDetails(
        { id: Number(data), role, profile_id: profileId },
        preferCacheValue,
      );
      const res = response.data;
      const watchingAtMinute = Number(res?.watching_at_minute ?? 0);
      const watchingSeason = Number(res?.watching_season ?? 0);
      const watchingChapter = Number(res?.watching_chapter ?? 0);

      if (res?.seasons?.length > 0) {
        const hasSavedEpisode =
          watchingAtMinute > 0 && watchingSeason > 0 && watchingChapter > 0;
        const savedSeason = hasSavedEpisode
          ? res.seasons.find(
              (season: any) => Number(season.season_number) === watchingSeason,
            )
          : null;
        const savedEpisode = savedSeason?.chapters?.find(
          (chapter: any) => Number(chapter.chapter_number) === watchingChapter,
        );
        const selectedSeason = savedSeason || res.seasons[0];
        const selectedEpisode = savedEpisode || selectedSeason?.chapters?.[0];

        if (selectedEpisode?.video) {
          dispatch(
            openVideoPlayer({
              id: Number(data),
              title: res.title || "",
              name: res.title || "",
              poster_path: res?.poster_path,
              type: res.type || "",
              videoData: selectedEpisode.video,
              serialData: {
                seasons: res.seasons,
                chapters: selectedSeason.chapters,
                seasonNumber: selectedSeason.season_number,
                episodeNumber: selectedEpisode.chapter_number,
                episodeTitle: selectedEpisode.title || "Episode 1",
              },
              watchingAtMinute,
              enabledResume:
                hasSavedEpisode &&
                Number(selectedSeason.season_number) === watchingSeason &&
                Number(selectedEpisode.chapter_number) === watchingChapter,
              contentContext,
            }),
          );
        }
      } else if (res?.video) {
        dispatch(
          openVideoPlayer({
            id: Number(data),
            title: res?.title || "",
            name: res?.title || "",
            poster_path: res?.poster_path,
            type: res?.type || "",
            videoData: res.video,
            isVideoPlayerOpen: isVideoPlayerOpen,
            watchingAtMinute,
            enabledResume: watchingAtMinute > 0,
            contentContext,
          }),
        );
      }
    } catch (error) {
      onError?.();
    } finally {
      setIsLoader(false);
    }
  } else {
    setIsLoader(false);
  }
};
